// extracted by mini-css-extract-plugin
export default {"options":"Caption_options__04We1","option":"Caption_option__u09D-","selected":"Caption_selected__LOHt3"};